import Demographics, { DemographicsState, mapDemographicsFromApi, mapDemographicsToApi } from '../models/Demographics'
import HashReturnObject from '../models/HashReturnObject';
import { getBaseAPI } from "../environments/Environments";
import { reject } from "q";
import { StateModel } from '../models/StateModel';
import { mapSessionData, SessionModel } from '../models/Session';

const DemographicsService = {
    getDemographics: (state: StateModel): Promise<HashReturnObject<Demographics>> => {
        var json = JSON.stringify(mapSessionData(state.session))
        return new Promise(async (resolve) => {
            const url = await getBaseAPI() + '/api/v1/Patient/getPatient_Demographics/';
            // const url = 'https://localhost:5001/api/v1/Patient/getPatient_Demographics/';
            fetch(url, {
                method: 'POST',
                body: JSON.stringify(mapSessionData(state.session)),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then((res) => res.json())
                .then((result) => Promise.resolve(result))
                .then((hashReturnObject: HashReturnObject<Demographics>) => {
                        resolve({
                            data: [ mapDemographicsFromApi(hashReturnObject.data[0]) ],
                            hash: hashReturnObject.hash,
                            sessionId: hashReturnObject.sessionId
                        });
                })
                .catch((e) => {
                    console.log('request error', e);
                    reject(e);
                });
        });
    },
    saveDemographics: (demographicsNew: Demographics, session: SessionModel): Promise<Demographics> => {
        return new Promise( async (resolve) => {
            const url = await getBaseAPI() + '/api/v1/Patient/savePatient_Demographics';
            var json = JSON.stringify(mapDemographicsToApi(demographicsNew, session))
            //  const url = 'https://localhost:5001/api/v1/Patient/savePatient_Demographics';
            fetch(url, {
              method: 'POST',
              body: JSON.stringify(mapDemographicsToApi(demographicsNew, session)),
              headers: {
                'Content-Type': 'application/json'
            }
            })
                .then((res) => res.json())
                .then((result) => Promise.resolve(result))
                .then((demographics) => {
                    resolve(demographics)
            })
                .catch((e) => {
                    console.log('request error', e);
                    reject(e);
                });
        });
    }
}
export default DemographicsService;